import { Button, Divider, Grow, Typography } from '@mui/material'
import React, { useContext, useEffect, useRef, useState } from 'react'
import dayjs from 'dayjs';
import { EvidenciasComponent } from './EvidenciasComponent';
import { UploadFile } from '@mui/icons-material';
import { AsuntosContext } from '../../pages/asuntos/AsuntosPage';
import { SubirEvidencia } from '../../helpers/AsuntosHelper';

export const AvanceComponent = ({avance}) => {
    const uploadInputRef = useRef(null);
    const imgMilitante = useRef(null);
    const {avanceSeleccionado, setAvanceSeleccionado} = useContext(AsuntosContext);

    const [archivo, setArchivo] = useState();
    const [selectedImage, setSelectedImage] = useState(null);
    const [file, setFile] = useState();

  const [imageUrl, setImageUrl] = useState(null);

  useEffect(() => {
    if (selectedImage) {
      setImageUrl(URL.createObjectURL(selectedImage));
    }
  }, [selectedImage]);

  const SeleccionImagen = (event) => {
//    setFile({file:event.target.files[0]});
//    console.log('selecciono imagen',event);

    const datos = new FormData();
    datos.append("fileToUpload", event.target.files[0]);   
    datos.append('idAvance', avanceSeleccionado);
    console.log('datos para subir imagen', datos);
    SubirEvidencia(datos, avanceSeleccionado).then(response => {
        console.log('la evidencia se subio', response);
    })


//     var reader = new FileReader();
//     reader.onload = function(){
//         console.log('se cargo imagen');
//     //    imgMilitante.current.src = reader.result;
// };
// reader.readAsDataURL(event.target.files[0]);
};




  return (
    <Grow timeout={800} in={true}>
        <div
            key={avance?.IdAvance}
            style={{
                display:'flex',
                flexDirection:'column'
            }}
        >

        <div
            style={{
                display:'flex',
                flexDirection:'row',
                justifyContent:'space-between',
                alignItems:'flex-end'
            }}
            >
            <Typography
                style={{
                    fontWeight:'bold',
                    fontSize:15
                }}
            >
                {avance.Usuario+' - '+avance.PorcentajeAvance}%
            </Typography>
            <input name="imgMilitante" onChange={event => SeleccionImagen(event) } ref={uploadInputRef} style={{visibility:'hidden'}} accept='.jpg' type="file" />

            <Button
                onClick={() => {setAvanceSeleccionado(avance.IdAvance); uploadInputRef.current && uploadInputRef.current.click()}}
                variant='outlined'
                size='small'
            >
                <UploadFile /> Subir evidencia
            </Button>
            <Typography
                style={{
                    fontSize:13,
                    color:'gray'
                }}
                >
            {dayjs(avance?.Fecha).format('DD/MM/YYYY')}
            </Typography>
        </div>
            <Divider style={{backgroundColor:'purple'}} />
            <Typography
                style={{
                    fontSize:13,
                    marginTop:5
                }}
            >
                {avance.Comentario}
            </Typography>
        <div
        
        >
            <EvidenciasComponent avance={avance} />
        </div>
    </div>
    </Grow>
  )
}
